import { render } from "./ContentTitle.vue?vue&type=template&id=4136f23d"
import script from "./ContentTitle.vue?vue&type=script&lang=js"
export * from "./ContentTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__